export default __webpack_public_path__ + "78fe27e5400897c33b4d27bd737f0a83.png";